import type { NostrEvent } from '@nostrify/nostrify';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { extractNIPTitle, extractNIPDTag } from '@/hooks/useCustomNIPsList';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

interface CustomNIPCardProps {
  event: NostrEvent;
}

export function CustomNIPCard({ event }: CustomNIPCardProps) {
  const title = extractNIPTitle(event);
  const dTag = extractNIPDTag(event);

  const timestamp = new Date(event.created_at * 1000).toLocaleDateString('de-DE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  if (!dTag) return null;

  return (
    <Link to={`/nip/${dTag}`}>
      <Card className="hover:shadow-lg transition-all duration-300 group">
        <CardHeader className="pb-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <FileText className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <CardTitle className="text-lg group-hover:text-primary transition-colors">
                {title || dTag}
              </CardTitle>
              <p className="text-xs text-muted-foreground mt-1">{timestamp}</p>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {event.content.substring(0, 150)}...
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
